"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactResizeDetector = require("react-resize-detector");

var _styles = require("@material-ui/core/styles");

var _getImageStyles = require("./utils/getImageStyles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    width: "100%",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: "hidden"
  },
  cropbox: {
    position: "absolute",
    overflow: props => {
      return props.overflow;
    },
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: "auto"
  },
  image: {
    position: "absolute",
    opacity: 1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "block",
    width: "auto",
    height: "auto",
    maxWidth: "100%",
    maxHeight: "100%",
    margin: "auto"
  }
}));

const ImageBase = ({
  className,
  imageUrl,
  imageCropdata,
  imageFocalpoint,
  imageFilters,
  objectFit = "contain",
  position = "absolute",
  overflow = "hidden",
  children,
  width,
  height,
  onLoad,
  onClick
}) => {
  const parentRef = (0, _react.useRef)(null);
  const cropboxRef = (0, _react.useRef)(null);
  const imageRef = (0, _react.useRef)(null);
  const classes = useStyles({
    overflow
  });

  const _useState = (0, _react.useState)(false),
        imageLoaded = _useState[0],
        setImageLoaded = _useState[1];

  const handleLoad = () => {
    const imageWidth = imageRef && imageRef.current && imageRef.current.offsetWidth;
    const imageHeight = imageRef && imageRef.current && imageRef.current.offsetHeight;
    const parentWidth = parentRef && parentRef.current && parentRef.current.offsetWidth;
    const parentHeight = parentRef && parentRef.current && parentRef.current.offsetHeight;
    const cropboxWidth = cropboxRef && cropboxRef.current && cropboxRef.current.offsetWidth;
    const cropboxHeight = cropboxRef && cropboxRef.current && cropboxRef.current.offsetHeight;
    setImageLoaded(true);
    onLoad && onLoad({
      parentRef,
      parentWidth: parentWidth,
      parentHeight: parentHeight,
      cropboxRef,
      cropboxWidth: cropboxWidth,
      cropboxHeight: cropboxHeight,
      imageRef,
      imageWidth: imageWidth,
      imageHeight: imageHeight
    });
  }; // get styles


  const _useState2 = (0, _react.useState)(null),
        cropboxStyle = _useState2[0],
        setCropboxStyle = _useState2[1];

  const _useState3 = (0, _react.useState)(null),
        imageStyle = _useState3[0],
        setImageStyle = _useState3[1];

  (0, _react.useEffect)(() => {
    if (!imageRef.current || !parentRef.current) {
      return;
    }

    const cropStyles = (0, _getImageStyles.getImageStyles)({
      imageCropdata,
      imageFocalpoint,
      imageFilters,
      objectFit,
      parentRef: parentRef,
      imageRef: imageRef
    });
    setCropboxStyle(cropStyles.cropbox);
    setImageStyle(cropStyles.image);
  }, [width, height, imageCropdata, imageFilters, imageLoaded]); // return cropped image with styles

  return _react.default.createElement("div", {
    className: className || classes.root,
    ref: parentRef
  }, _react.default.createElement("div", {
    className: classes.cropbox,
    ref: cropboxRef,
    style: cropboxStyle,
    onClick: onClick
  }, _react.default.createElement("img", {
    src: imageUrl,
    className: classes.image,
    ref: imageRef,
    style: imageStyle,
    onLoad: handleLoad
  }), children));
};

ImageBase.defaultProps = {
  imageCropdata: {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }
};

var _default = (0, _reactResizeDetector.withResizeDetector)(ImageBase);

exports.default = _default;
module.exports = exports.default;